import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Tenant } from '../utils/models/tenant.model';
import { API_BASE_URL } from './tokens';

@Injectable()
export class TenantApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private tenantUrl: string;
  private tenantWithCountUrl: string;
  private _tenants = new BehaviorSubject<Tenant[]>([]);

  constructor() {
    const baseUrl = this.baseUrl;

    this.tenantUrl = baseUrl + '/tenant';
    this.tenantWithCountUrl = baseUrl + '/tenantsWithCountOfMembers';
  }

  public get$(reload = true): Observable<Tenant[]> {
    if (!reload) {
      return this._tenants.asObservable();
    }

    return this.http
      .get<Tenant[]>(this.tenantWithCountUrl)
      .pipe(tap((data) => this._tenants.next(data)));
  }

  public delete$(id: string): Observable<boolean> {
    return this.http.delete(`${this.tenantUrl}/${id}`).pipe(map((result: boolean) => result));
  }

  public create$(tenant: Partial<Tenant>): Observable<Tenant> {
    return this.http.post<Tenant>(this.tenantUrl, tenant);
  }
}
